<template>
  <div :class="fullWidth ? 'w-full' : 'w-auto'">
    <!-- Label -->
    <label v-if="label" :for="inputId" class="font-bold text-mouse mb-1">
      {{ label }}
      <span v-if="required" class="text-brand ms-0.5">*</span>
    </label>

    <!-- Slot for input/select/textarea -->
    <slot></slot>

    <!-- Hint -->
    <p
      v-if="hint"
      :class="[
        'text-rhino',
        isTextarea ? '' : 'mt-1', // No mt-1 for textarea to maintain consistent spacing
      ]"
    >
      {{ hint }}
    </p>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    label?: string;
    hint?: string;
    inputId?: string;
    fullWidth?: boolean;
    required?: boolean;
    isTextarea?: boolean; // Special flag for textarea hint spacing
  }>(),
  {
    label: undefined,
    hint: undefined,
    inputId: undefined,
    fullWidth: false,
    required: false,
    isTextarea: false,
  },
);
</script>
<style scoped></style>
